module.exports = __webpack_public_path__ + "static/media/and_scr_date_picker.2664cd03.png";